import { DtoMapper } from '@wemogy/reactbase';
import {IDatabaseTemplate} from '../../models/DatabaseTemplate';

export default class DatabaseTemplateDtoMapper extends DtoMapper<IDatabaseTemplate, any>{

}
